const size = {
    phone: '699px',
    tabletPortrait: '700px',
    tabletLandscape: '900px',
    desktop: '1200px',
    bigDesktop: '1800px'
  };

export const device = {
    phone: `(max-width: ${size.phone})`,
    tabletPortrait: `(max-width: ${size.tabletPortrait})`,
    tabletLandscape: `(min-width: ${size.tabletLandscape})`,
    desktop: `(min-width: ${size.desktop})`,
    bigDesktop: `(min-width: ${size.bigDesktop})`
};




// phone 350 - 700
// ipad 700 - 1024
// destop min-width: 1024


// WEBPACK FOOTER //
// ./src/theme/device.js